import { Component, OnInit, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDatepickerInputEvent, DateAdapter, MAT_DATE_FORMATS, MatDialog, MatDialogConfig } from '@angular/material';
import { DateFormat, APP_DATE_FORMATS } from 'src/app/core/shared/date-Format';
import { SelectTestingDialogComponent } from 'src/app/core/modal/select-testing-dialog/select-testing-dialog.component';
import { Testing } from '../../requets/shared/model/testing.model';
import { SelectItemDialogComponent } from 'src/app/core/modal/select-item-dialog/select-item-dialog.component';
import { FilterRequestTest } from '../shared/filter-request-test.model';



@Component({
  selector: 'app-search-fields-test',
  templateUrl: './search-fields-test.component.html',
  styleUrls: ['./search-fields-test.component.scss']
})
export class SearchFieldsTestComponent implements OnInit {

  dateFormControlFirts: Date;

  dateFormControlEnd: Date;
  selectedValue: any[] = [];
  statesList: any[] = [];
  enabledSpinner = false;
  minDateF = new Date(1500, 0, 1);
  maxDateF = new Date();
  minDateE = new Date(1500, 0, 1);
  maxDateE = new Date();
  tests = '';
  @Input() testing: Testing[] = [];
  @Input() testingSelect: Testing[] ;

  @Output()
  sendSearchRequest: EventEmitter<any> = new EventEmitter();

  allItem: any = { codigo: 'T', nombre: 'Todos'};

  constructor(private dialog: MatDialog) { }

  ngOnInit() {
    this.statesList.push({ codigo: 'A', nombre: 'Aceptado'});
    this.statesList.push({ codigo: 'P', nombre: 'Aplazado'});
    this.statesList.push({ codigo: 'R', nombre: 'Rechazado'});
    this.statesList.push({ codigo: 'E', nombre: 'En proceso'});

  }


  validateField() {
    let validate = false;
    if (!this.dateFormControlFirts || !this.dateFormControlEnd) {
      validate = true;
    }
    return validate;
  }

  addEvent(name: String, event: MatDatepickerInputEvent<Date>) {
    if (name === 'dpF') {
      this.dateFormControlFirts = event.value;
      if (!this.dateFormControlEnd) {
        this.minDateE = event.value;
      } else if (this.dateFormControlFirts.toDateString() ===  this.dateFormControlEnd.toDateString()) {
        this.minDateE = new Date(1500, 0, 1);
      } else {
        this.minDateE = event.value;
      }
    } else {
      this.dateFormControlEnd = event.value;
      if (!this.dateFormControlFirts) {
        this.maxDateF = event.value;
      } else if (this.dateFormControlFirts.toDateString() ===  this.dateFormControlEnd.toDateString()) {
        this.maxDateF  = new Date();
      } else {
        this.maxDateF = event.value;
      }
    }
  }
  openDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data =  { data: this.testing, tittle: 'Seleccionar Pruebas' ,
                     codigo: 'codigo', nombre : 'nombre', select : this.testingSelect};
    dialogConfig.width = '50%';
    const dialogRef = this.dialog.open(SelectItemDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(
      (value) => {
        if (value !== null) {
          this.testingSelect = value.item as Testing[];
          this.tests = '';
          let index = 0;
          if (this.testingSelect) {
            this.testingSelect.forEach( (element) => {
              if (index === 0) {
                this.tests = element.nombre + '(' +  element.codigo + ')';
              } else {
                this.tests =  this.tests + ',' + element.nombre + '(' +  element.codigo + ')';
              }
              index++;
            });
          }
        }
      }
    );
  }
  sendSearchParam() {
    const fielSearch =  new FilterRequestTest();
    fielSearch.fechaInicial =  this.getDateFormat(this.dateFormControlFirts);
    fielSearch.fechaFinal =  this.getDateFormat(this.dateFormControlEnd);

    if (this.selectedValue) {
      if (this.selectedValue.length === 0) {
        fielSearch.estados = 'T';
      } else {
        fielSearch.estados = this.getState();
      }

    }
    if (this.testingSelect) {
      fielSearch.pruebas = this.getTest();
    }
    this.sendSearchRequest.emit(fielSearch);
  }

  private getDateFormat (date: Date) {
    const locaDate = date.toLocaleString().split('/');
    const dia = Number(locaDate[0]) <= 9 ? '0' + locaDate[0] : locaDate[0];
    const mes = Number(locaDate[1]) <= 9 ? '0' + locaDate[1] : locaDate[1];
    const year = date.getFullYear();
    return dia + '/' + mes + '/' + year;
  }

  private getState() {
    let states = '';
    if (this.selectedValue) {
      this.selectedValue.forEach((element) => {
        states = states  + element + ',';
      });
    }
    return states.substring(0, states.length - 1);
  }

  private getTest() {
    let tests = '';
    if (this.testingSelect) {
      this.testingSelect.forEach((element) => {
        tests = tests + element.idprueba + ',';
      });
    }

    return tests.substring(0, tests.length - 1);
  }

  validateAll() {
    let validate = true;
    if (this.selectedValue.find( element => element === 'T' ) || this.selectedValue.length === this.statesList.length ) {
      validate = false;
    }
    if (this.selectedValue.length === this.statesList.length ) {
      this.selectedValue.push(this.allItem.codigo);
    }
    return validate;
  }


}
